import { render, staticRenderFns } from "./RegisterIndividual.vue?vue&type=template&id=d4ed30a4"
import script from "./RegisterIndividual.vue?vue&type=script&lang=js"
export * from "./RegisterIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports